module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "hint hint--left btn btn--info",
    class: {
      'is-loading': _vm.addingImage
    },
    attrs: {
      "slot": "header-actions",
      "disabled": _vm.addingImage,
      "data-label": "Adicionar uma imagem em uma ou mais variações"
    },
    on: {
      "click": function($event) {
        _vm.addingImage = true
      }
    },
    slot: "header-actions"
  }, [_vm._v("\n      Adicionar Imagem\n    ")]), _vm._v(" "), _c('modal-add-image', {
    attrs: {
      "visible": _vm.addingImage,
      "variations": _vm.product.variations,
      "callback": _vm.uploadedImage,
      "module": _vm.moduleUploadImageModal
    },
    on: {
      "close": function (close) { return _vm.addingImage = close; }
    }
  })], 1), _vm._v(" "), (_vm.category.variations_combinations.length && !_vm.typeCheckout) ? _c('div', _vm._l((_vm.product.variations), function(variation) {
    return _c('variation-type-multi', {
      key: variation,
      attrs: {
        "productId": _vm.product.productId,
        "variation": variation,
        "category": _vm.category,
        "fromModule": _vm.fromModule,
        "product": _vm.product
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.category.variations_combinations.length || _vm.typeCheckout) ? _c('variation-type-single', {
    attrs: {
      "product": _vm.product,
      "typeCheckout": _vm.typeCheckout,
      "category": _vm.category,
      "fromModule": _vm.fromModule
    },
    on: {
      "changeTypeCheckout": _vm.changeTypeCheckout
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54817b7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/Variation.vue
// module id = 3173
// module chunks = 0